import controller from './html.controller';
import template from './html.template.html';

const component = {
	bindings: {
		html: '<'
	},
	controller,
	controllerAs: 'vm',
	template,
	transclude: true
};

export default component;



// WEBPACK FOOTER //
// ./src/modules/side-menu/components/html/index.js